import { CursorPaginatedResponseSchema, addOptionalCursorPaginationQuery, } from 'notable-common';
import { z } from 'zod';
import { NotificationContentCloneSchema, NotificationContentCreateSchema, NotificationContentFindAllQuerySchema, NotificationContentParamsSchema, NotificationContentSchema, NotificationContentUpdateSchema, } from './content.js';
import { NotificationIntentFindAllQuerySchema, NotificationIntentSchema } from './intent.js';
const TAGS = ['Notifications'];
export const NOTIFICATION_CONTENTS_BASE_ROUTE = '/notification-contents';
export const NOTIFICATION_INTENTS_BASE_ROUTE = '/notification-intents';
/** Paginated when the caller asks for a page, a bare array otherwise. */
const NotificationContentListResponseSchema = z.union([
    CursorPaginatedResponseSchema(NotificationContentSchema),
    z.array(NotificationContentSchema),
]);
export const NotificationContentListRoute = {
    method: 'get',
    fullPath: NOTIFICATION_CONTENTS_BASE_ROUTE,
    summary: 'List notification contents',
    tags: TAGS,
    /*
     * Paging without sorting: the handler validates `sort` against no sortable columns, so every
     * value it could carry is rejected. Publishing it would advertise a parameter the server 400s on.
     */
    query: addOptionalCursorPaginationQuery(NotificationContentFindAllQuerySchema).omit({
        sort: true,
    }),
    response: NotificationContentListResponseSchema,
};
export const NotificationContentGetRoute = {
    method: 'get',
    fullPath: `${NOTIFICATION_CONTENTS_BASE_ROUTE}/:contentId`,
    summary: 'Get a notification content by ID',
    tags: TAGS,
    params: NotificationContentParamsSchema,
    response: NotificationContentSchema,
};
export const NotificationContentCreateRoute = {
    method: 'post',
    fullPath: NOTIFICATION_CONTENTS_BASE_ROUTE,
    summary: 'Create a notification content',
    tags: TAGS,
    body: NotificationContentCreateSchema,
    response: NotificationContentSchema,
};
export const NotificationContentCloneRoute = {
    method: 'post',
    fullPath: `${NOTIFICATION_CONTENTS_BASE_ROUTE}/:contentId/clone`,
    summary: 'Copy a notification content under a new name',
    tags: TAGS,
    params: NotificationContentParamsSchema,
    body: NotificationContentCloneSchema,
    response: z.object({ id: z.uuid() }),
};
export const NotificationContentUpdateRoute = {
    method: 'patch',
    fullPath: `${NOTIFICATION_CONTENTS_BASE_ROUTE}/:contentId`,
    summary: 'Update a notification content',
    tags: TAGS,
    params: NotificationContentParamsSchema,
    body: NotificationContentUpdateSchema,
    response: NotificationContentSchema,
};
export const NotificationContentRemoveRoute = {
    method: 'delete',
    fullPath: `${NOTIFICATION_CONTENTS_BASE_ROUTE}/:contentId`,
    summary: 'Delete a notification content',
    description: 'Soft-deletes the content if anything still references it, hard-deletes it otherwise.',
    tags: TAGS,
    params: NotificationContentParamsSchema,
    response: z.object({ success: z.boolean() }),
};
export const NotificationIntentListRoute = {
    method: 'get',
    fullPath: NOTIFICATION_INTENTS_BASE_ROUTE,
    summary: 'List the reply intents defined across notification contents',
    tags: TAGS,
    query: NotificationIntentFindAllQuerySchema,
    response: z.array(NotificationIntentSchema),
};
//# sourceMappingURL=routes.js.map